
import {IUserPurchases} from "@/interfaces/mlm";
import { Component, Prop, Vue } from "vue-property-decorator";
// import exampleJson from "./purchase_example.json"
import ReferralTable from "./ReferralTable.vue";
@Component({
    components:{
        ReferralTable
    }
})
export default class ReferralTableList extends Vue {
    @Prop({ type: [], default: [] }) readonly purchases!: IUserPurchases[];
    // exampleJson = exampleJson
}

